import { createBookingDraftAPIClient } from './bookingDraftApiClient';

export const bookingDraftApiClient = createBookingDraftAPIClient({});
